/**
 * Allows you to add data-method="METHOD to links to automatically inject a form
 * with the method on click
 *
 * Example: <a href="{{route('customers.destroy', $customer->id)}}"
 * data-method="delete" name="delete_item">Delete</a>
 *
 * Injects a form with that's fired on click of the link with a DELETE request.
 * Good because you don't have to dirty your HTML with delete forms everywhere.
 */
function addDeleteForms() {
  $('[data-method]').append(function () {
    if (!$(this).find('form').length > 0) {
      return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
        "<input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
        "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
        '</form>\n';
    } else { return '' }
  })
    .attr('href', '#')
    .attr('style', 'cursor:pointer;')
    .attr('onclick', '$(this).find("form").submit();');
}

// Restricts input for the given textbox to the given inputFilter function.
window.setInputFilter = function (textbox, inputFilter) {
  ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
    textbox.addEventListener(event, function () {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}

/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
  /**
   * Add the data-method="delete" forms to all delete links
   */
  addDeleteForms();

  /**
   * Disable all submit buttons once clicked
   */
  $('form').submit(function () {
    $(this).find('input[type="submit"]').attr('disabled', true);
    $(this).find('button[type="submit"]').attr('disabled', true);
    return true;
  });

  /**
   * Generic confirm form delete using Sweet Alert
   */
  $('body').on('submit', 'form[name=delete_item]', function (e) {
    e.preventDefault();

    const form = this;
    // var link = $('a[data-method="delete"]');
    // var cancel = link.attr('data-trans-button-cancel') ? link.attr('data-trans-button-cancel') : 'Cancel';
    // var confirm = link.attr('data-trans-button-confirm') ? link.attr('data-trans-button-confirm') : 'Yes, delete';
    // var title = link.attr('data-trans-title') ? link.attr('data-trans-title') : 'Are you sure you want to delete this item?';
    var link = form.closest('a[data-method="delete"]');
    var cancel = (link.getAttribute('data-trans-button-cancel')) ? link.getAttribute('data-trans-button-cancel') : 'Cancel';
    var confirm = (link.getAttribute('data-trans-button-confirm')) ? link.getAttribute('data-trans-button-confirm') : 'Yes, delete';
    var title = (link.getAttribute('data-trans-title')) ? link.getAttribute('data-trans-title') : 'Are you sure you want to do this?';

    Swal.fire({
      title: title,
      showCancelButton: true,
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      icon: 'warning'
    }).then((result) => {
      result.value && form.submit();
    });
  }).on('click', 'a[name=confirm_item]', function (e) {
    /**
     * Generic 'are you sure' confirm box
     */
    e.preventDefault();

    const link = $(this);
    const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to do this?';
    const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
    const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Continue';

    Swal.fire({
      title: title,
      showCancelButton: true,
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      icon: 'info'
    }).then((result) => {
      result.value && window.location.assign(link.attr('href'));
    });
  }).on('submit', 'form[name=post_item].submitAfterConfirm', function (e) {
    e.preventDefault();
    const form = this;
    var link = form.closest('a[data-method]');
    var cancel = (link.getAttribute('data-trans-button-cancel')) ? link.getAttribute('data-trans-button-cancel') : 'Cancel';
    var confirm = (link.getAttribute('data-trans-button-confirm')) ? link.getAttribute('data-trans-button-confirm') : 'Yes, delete';
    var title = (link.getAttribute('data-trans-title')) ? link.getAttribute('data-trans-title') : 'Are you sure you want to do this?';

    Swal.fire({
      title: title,
      showCancelButton: true,
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      icon: 'warning'
    }).then((result) => {
      result.value && form.submit();
    });
  });

  $('[data-toggle="tooltip"]').tooltip();
});

// Select input add checkbox
$(".select2").select2({
  closeOnSelect: false,
  placeholder: "Placeholder",
  allowHtml: true,
  allowClear: true,
  tags: true // создает новые опции на лету
});